import { getCookie } from '@utiljs/cookie';

// import { getEnv, ENV } from '@utils/getEnv';
// import * as Ids from '@utils/ids';
import request from '@utils/axiosWrapper';
import { MessageNotification } from '@projects/Shell/store/models/pushNotification';

// const currentEnv = getEnv();

// let requestDomain = `${window.location.protocol}//brook-e.waimai.meituan.com`;
// if (currentEnv === ENV.TEST) {
//     requestDomain = 'http://brook.waimai.test.meituan.com';
// } else if (currentEnv === ENV.STAGE) {
//     requestDomain = 'https://brook.waimai.st.meituan.com';
// }

/** 为消息构建要上报的数据 */
// const buildMsgReportParams = (msg: MsgLikeObj) => {
//     return {
//         token: getCookie('pushToken'),
//         wmEPoiMsgId: msg.wmEPoiMsgId,
//         wmEMsgTraceId: msg.wmEMsgTraceId,
//         receiveTime: new Date().getTime(),
//         reportStage: 32,
//     };
// };

// /** 通用上报参数 */
// const commonReportData = {
//     acctId: Ids.getAcctId(),
//     token: Ids.getToken(),
//     appType: 3,
// };

// type MsgLikeObj = {
//     wmEPoiMsgId: string;
//     wmEMsgTraceId: string;
//     wmPoiId?: string;
//     wm_poi_id?: string;
//     noticeId?: string;
// };

/**
 * 消息到达回执
 */
// const reportArrive = (msg: MsgLikeObj) => {
//     if (msg.wmEMsgTraceId) {
//         const reportParams = buildMsgReportParams(msg);
//         const requestPayload = {
//             ...commonReportData,
//             wmPoiId: msg.wmPoiId || msg.wm_poi_id,
//             data: JSON.stringify([reportParams]),
//             ...(msg.noticeId ? { noticeId: msg.noticeId } : {}),
//         };

//         request
//             .postAsFormSubmit(`${requestDomain}/api/push/trace/batchReport`, requestPayload)
//             .then(
//                 // NOTE: 由于线上pushToken与门店的绑定关系存在不同步问题，因此可能产生异常
//                 () => null,
//                 () => null,
//             );
//     }
// };

/** 统一触达消息已读回执 */
const reportUnifiedBusinessMessageNoticeRead = (
    reportData: Pick<
        MessageNotification,
        'wmEMsgTraceId' | 'wmEPoiMsgId' | 'noticeId' | 'templateName' | 'noticeType'
    >,
    clickInfo?: {
        clickButtonText: string;
        clickButtonType: 'CONFIRM' | 'CANCEL' | 'CONVERT';
        utmContent?: string;
    },
) => {
    if (reportData.templateName && reportData.noticeType)
        request
            .postAsFormSubmit('/gw/api/push/trace/read', {
                token: getCookie('pushToken'),
                data: JSON.stringify({
                    wmEMsgTraceId: reportData.wmEMsgTraceId,
                    wmEPoiMsgId: reportData.wmEPoiMsgId,
                    id: reportData.noticeId,
                    templateName: reportData.templateName,
                    noticeType: reportData.noticeType,
                    ...(clickInfo || {}),
                }),
            })
            .then(
                () => null,
                () => null,
            );
};

// eslint-disable-next-line import/prefer-default-export
export { reportUnifiedBusinessMessageNoticeRead };
